export default __webpack_public_path__ + "static/media/Hero's Clan Blade.758223f1.jpg";